import { Stack } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import {
  FirstName,
  LastName,
  PrimaryFormDateOfBirth,
  StyledButton,
  ZipCode,
} from "react-common-ui-library";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CONTAINED,
  LINK_APPLICATION_ROUTE,
  MODE_ALL,
  SUBMIT,
} from "../../../Constants/CommonConstants";
import {
  APPLICATION_ALREADY_EXIST,
  APPLICATION_ALREADY_LINKED,
  APPLICATION_LINKED_SUCCESSFULLY,
  LINK_APPLICATION_FORM_ID,
  LINK_APPLICATION_RESULTS_ROUTE,
  LINK_APPLICATION_SEARCH_BUTTON,
  NAME_DATE_OF_BIRTH,
  NAME_FIRST_NAME,
  NAME_LAST_NAME,
  NAME_SEX,
  NAME_ZIP_CODE,
  NO_APPLICATION_FOUND,
} from "../../../Constants/LinkMyApplicationConstants";
import { FLOW_TEXT_APPLICATION } from "../../../Constants/NoMatchFoundModalConstants";
import {
  SLICE_LINK_APPLICATION,
  THUNK_POST_SEARCH_LINK_APPLICATION,
} from "../../../Constants/SliceAndThunkConstants";
import {
  clearLinkApplicationResponse,
  postSearchLinkApplication,
  saveSearchHapId,
} from "../../../Features/LinkApplicationSlice";
import { manageApiResponseSelector } from "../../../Selectors/ApiResponseSelector";
import { manageLinkApplicationSelector } from "../../../Selectors/LinkApplicationSelector";
import { trimData } from "../../../Services/CommonServices";
import { StyledSmallerFieldWrapperBox } from "../../../Styles/Common/CommonStyles";
import {
  StyledFieldNameWrapperBox,
  StyledSubmitButtonBox,
} from "../../../Styles/LinkApplication/LinkMyApplication";
import NoMatchFoundModal from "../../Common/NoMatchFoundModal/NoMatchFoundModal";
import SearchHAPIdAlert from "./SearchHAPIdAlert";
import SearchHAPIdSex from "./SearchHAPIdSex";

const SearchHapIdForm = () => {
  const intl = useIntl();

  const [openNoMatchFoundModal, setOpenNoMatchFoundModal] = useState(false);

  const {
    searchForHapIdDataDateOfBirth,
    searchForHapIdDataFirstName,
    searchForHapIdDataLastName,
    searchForHapIdDataSexCode,
    searchForHapIdDataZipCode,
  } = useSelector((state) => manageLinkApplicationSelector(state));

  const { apiResponses } = useSelector((state) =>
    manageApiResponseSelector(
      state,
      SLICE_LINK_APPLICATION,
      THUNK_POST_SEARCH_LINK_APPLICATION
    )
  );

  const { isSuccess, description } = apiResponses;

  const methods = useForm({
    mode: MODE_ALL,
    defaultValues: {
      [NAME_FIRST_NAME]: searchForHapIdDataFirstName,
      [NAME_LAST_NAME]: searchForHapIdDataLastName,
      [NAME_SEX]: searchForHapIdDataSexCode,
      [NAME_ZIP_CODE]: searchForHapIdDataZipCode,
      [NAME_DATE_OF_BIRTH]: searchForHapIdDataDateOfBirth,
    },
  });

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const formData = trimData(data);
    dispatch(saveSearchHapId(formData));
    dispatch(postSearchLinkApplication(formData));
  };

  useEffect(() => {
    if (isSuccess) {
      if (description === APPLICATION_LINKED_SUCCESSFULLY) {
        navigate(
          `/${LINK_APPLICATION_ROUTE}/${LINK_APPLICATION_RESULTS_ROUTE}`
        );
      }
      if (
        description === NO_APPLICATION_FOUND ||
        description === APPLICATION_ALREADY_LINKED ||
        description === APPLICATION_ALREADY_EXIST
      ) {
        setOpenNoMatchFoundModal(true);
      }
      dispatch(
        clearLinkApplicationResponse(THUNK_POST_SEARCH_LINK_APPLICATION)
      );
    }
  }, [description, isSuccess, navigate, dispatch]);

  return (
    <Fragment>
      <Stack spacing={{ xs: 4, md: 5 }}>
        <FormProvider {...methods}>
          <form
            id={LINK_APPLICATION_FORM_ID}
            onSubmit={methods.handleSubmit(onSubmit)}
          >
            <Stack spacing={4}>
              <StyledFieldNameWrapperBox>
                <Stack spacing={4}>
                  <FirstName />
                  <LastName />
                </Stack>
              </StyledFieldNameWrapperBox>
              <Stack spacing={{ xs: 8, md: 7 }}>
                <StyledSmallerFieldWrapperBox>
                  <Stack spacing={4}>
                    <PrimaryFormDateOfBirth />
                    <ZipCode />
                    <SearchHAPIdSex />
                  </Stack>
                </StyledSmallerFieldWrapperBox>
                <Stack spacing={{ xs: 5, md: 10 }}>
                  <SearchHAPIdAlert />
                  <StyledSubmitButtonBox>
                    <StyledButton
                      type={SUBMIT}
                      variant={CONTAINED}
                      id={LINK_APPLICATION_SEARCH_BUTTON}
                    >
                      {intl.formatMessage({
                        id: LINK_APPLICATION_SEARCH_BUTTON,
                      })}
                    </StyledButton>
                  </StyledSubmitButtonBox>
                </Stack>
              </Stack>
            </Stack>
          </form>
        </FormProvider>
      </Stack>
      <NoMatchFoundModal
        flow={FLOW_TEXT_APPLICATION}
        open={openNoMatchFoundModal}
        setOpen={setOpenNoMatchFoundModal}
      />
    </Fragment>
  );
};

export default SearchHapIdForm;
